import "./VerifyEmail.css";

import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { resendEmailVerification, updateProfile, verifyEmail } from "../../api/auth";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import CustomInput from "../../components/CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import ReactLoading from "react-loading";
import { setAccount } from "../../store/fine/fineActions";
import { setAuthLoading } from "../../store/auth/authActions";
import { setLoginVisible } from "../../store/modals/modalActions";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const url = searchParams.get("url");
  const resendCode = searchParams.get("resend_code");
  const decodedURL = decodeURI(url!);
  const dispatch = useAppDispatch();
  const [status, setStatus] = useState<string>("");
  const [requested, setRequested] = useState(false);
  const [verified, setVerified] = useState(false);
  const [emailResent, setEmailResent] = useState<boolean>(false);
  const [emailResentMessage, setEmailResentMessage] = useState<string>();
  const [message, setMessage] = useState<string>();
  const user = useAppSelector((state) => state.auth.user);
  const authLoading = useAppSelector((state) => state.auth.loading);
  const [loading, setLoading] = useState<boolean>(false);
  const modalState = useAppSelector((state) => state.modal);

  const infringement = useAppSelector((state) => state.fine.infringement);

  const [newEmail, setNewEmail] = useState<string>("");
  const [newEmailSubmittedResp, setNewEmailSubmittedResp] = useState<any>(null);

  useEffect(() => {
    if (infringement && user && user.is_verified) navigate("/fine");
  }, [infringement, user]);

  useEffect(() => {
    dispatch(setAuthLoading(false));
    if (!resendCode) {
      if (!url) {
        navigate("/");
      } else {
        verifyEmail(url)
          .then((resp: any) => {
            setVerified(resp.status);
            setMessage(resp.message);
            if (resp.account) {
              dispatch(setAccount(resp.account));
            }
          })
          .finally(() => {
            setRequested(true);
          });
      }
    } else {
      setVerified(false);
    }
  }, []);

  const onLoginClicked = () => {
    dispatch(setLoginVisible(true));
  };

  const onReturnClicked = () => {
    navigate("/");
  };

  const onResendClicked = () => {
    setLoading(true);
    const splitURL = decodedURL.split("/");
    const id = splitURL[4];
    const hash = splitURL[5].substring(0, splitURL[5].indexOf("?"));
    resendEmailVerification(id, hash)
      .then(({ message, status }: any) => {
        setStatus(status);
        setEmailResent(true);
        setEmailResentMessage(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangeEmailClicked = async () => {
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(newEmail)) {
      setNewEmailSubmittedResp({
        status: false,
        message: "Please enter a valid email address",
      });
      return;
    }
    setNewEmailSubmittedResp(null);
    setLoading(true);
    let status = await updateProfile(newEmail, user?.mobile_number!, true);
    setNewEmailSubmittedResp(status);
    setLoading(false);
  };

  return (
    <div className="verify-email-container">
      {authLoading && !modalState.loginVisible && (
        <>
          <div className="register-overlay" />
          <div
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              marginLeft: "100vw",
              marginTop: "50vh",
            }}
          >
            <ReactLoading type="bubbles" color="#e97700" height={"5%"} width={"5%"} />
          </div>
        </>
      )}
      <Header title="City of Cape Town - Traffic Fines" hideLoginButton />
      <div className="verify-email-content">
        {verified && requested ? (
          <>
            <div className="verify-email-heading">
              {message && (
                <>
                  <FontAwesomeIcon icon={faCheck} size="2x" color="#18283c" />
                  <p>{message}</p>
                </>
              )}
            </div>
            {!user ? (
              <div className="verify-login-button" onClick={() => !authLoading && onLoginClicked()}>
                <p>Login</p>
              </div>
            ) : (
              <div className="verify-login-button" onClick={() => onReturnClicked()}>
                <p>Return to Home</p>
              </div>
            )}
          </>
        ) : requested || !resendCode ? (
          <>
            {message && (
              <>
                <div className="verify-email-heading">
                  {!emailResent ? (
                    <FontAwesomeIcon icon={faTimes} size="2x" color="#18283c" />
                  ) : status === "error" ? (
                    <FontAwesomeIcon icon={faTimes} size="2x" color="#18283c" />
                  ) : (
                    <FontAwesomeIcon icon={faCheck} size="2x" color="#18283c" />
                  )}

                  {!emailResent ? (
                    <p>{message}</p>
                  ) : (
                    <>
                      {emailResentMessage ? (
                        <p>{emailResentMessage}</p>
                      ) : (
                        <p>Verification email resent</p>
                      )}
                    </>
                  )}
                </div>
                {!emailResent && (
                  <div className="verify-login-button" onClick={() => onResendClicked()}>
                    {!loading ? <p>Resend Code</p> : <ReactLoading type="bubbles" color="white" />}
                  </div>
                )}
              </>
            )}
          </>
        ) : !newEmailSubmittedResp || (newEmailSubmittedResp && !newEmailSubmittedResp?.status) ? (
          <>
            <div className="verify-email-heading" style={{ maxWidth: "55%" }}>
              <FontAwesomeIcon icon={faTimes} />

              <p>Your email has not been verified</p>
            </div>
            <p className="mailbox-text">Please check your mailbox</p>
            <div className="new-verify-email-container">
              <p>or</p>
              <CustomInput
                label="Enter an email address"
                placeholder="Email Address"
                value={newEmail}
                setValue={setNewEmail}
                containerStyle={{ width: "fit-content" }}
                inputStyle={{
                  height: window.innerWidth > 480 ? 50 : 32,
                  width: window.innerWidth > 480 ? 400 : 180,
                  marginTop: 5,
                }}
              />
              {newEmailSubmittedResp && newEmailSubmittedResp?.message ? (
                <p className="error-text">{newEmailSubmittedResp?.message}</p>
              ) : null}
              {newEmail.length > 0 ? (
                <div className="verify-login-button" onClick={() => onChangeEmailClicked()}>
                  {!loading ? <p>Submit</p> : <ReactLoading type="bubbles" color="white" />}
                </div>
              ) : null}
            </div>
          </>
        ) : (
          <>
            <div className="verify-email-heading" style={{ maxWidth: "55%" }}>
              <FontAwesomeIcon icon={faCheck} size="2x" color="#18283c" />
              <p>Email verification resent</p>
            </div>
            <p className="mailbox-text">Please check your mailbox</p>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default VerifyEmail;
